import Api from 'services/Api'
import Logger from 'services/Logger'
import { AccountDoc } from 'types/api/changes'
import { is24meApp } from 'utils/appType'

export interface AccountStorageResponse {
  totalStorageBytes: number
  storageQuotaBytes: number | null
  storageRemainingBytes: number | null
  totalPhotos: number
  photoQuotaLimit: number | null
  photosRemaining: number | null
  photosByGroup?: Record<string, number>
}

export async function updateAccountOnServer(acc: AccountDoc) {
  Logger.pink('Updating account on server', acc)
  return await Api.post(`/general/account/edit/${acc._id}`, {
    _id: acc._id,
    _rev: acc._rev,
    UserID: acc.UserID,
    LastUpdate: acc.LastUpdate,
    DeviceChangeID: acc.DeviceChangeID,
    AccessToken: acc.AccessToken,
    AppleID: acc.AppleID,
    Devices: acc.Devices,
    Email: acc.Email,
    PaymentEmail: acc.PaymentEmail,
    Products: acc.Products,
    FacebookID: acc.FacebookID,
    Name: JSON.parse(JSON.stringify(acc.Name)),
    Password: acc.Password,
    PhoneNumber: acc.PhoneNumber,
    PhoneNumberType: acc.PhoneNumberType,
    TokenExpires: acc.TokenExpire,
    UserType: JSON.parse(JSON.stringify(acc.UserType)),
    ConnectedCalAccounts: acc.ConnectedCalAccounts
      ? JSON.parse(JSON.stringify(acc.ConnectedCalAccounts))
      : undefined,
    groupcalActivatedDate: acc.groupcalActivatedDate,
    isDeleted: JSON.parse(JSON.stringify(acc.isDeleted)),
    Type: 'Account'
  })
}

export async function forgotPassword(email: string) {
  return await Api.post('/general/forgotpass', {
    email: email
  })
}

export async function deleteAccount(accountId: string) {
  return await Api.post(`/general/account/deactivation/${accountId}`, {})
}

export async function getAccountStorage(userId: string, signal?: AbortSignal) {
  const storagePath = is24meApp() ? 'tfmstorage' : 'storage'

  return await Api.get(`/v1/account/${userId}/${storagePath}`, {
    signal
  }).then((response) => response.data as AccountStorageResponse)
}
